import $ from "jquery";
import Popper from "popper.js";
import "bootstrap";
import svg4everybody from "svg4everybody";

window.$ = $;
window.jQuery = $;
window.Popper = Popper;

svg4everybody({
  validate: function(src, svg, use) {
    const $svg = $(svg);
    const shouldIgnore = $svg.hasClass("svg4everybody-ignore");
    return !shouldIgnore;
  },
});
